export default "__VITE_ASSET__22518cf6__"